const paymentDialog = (() => {
    const STRIPE_PUBLISHABLE_KEY = 'pk_test_51RaobTB6HOc3L6j736xDALckm2c6lXal3wydrveMvQ2T6FOmLyMYqUP1sv710Q4JFCJyLIw28flZXc7pyq01yBoc005Ohcfsl4';


  let stripeInstance = null;
  let elementsInstance = null;
  let paymentElement = null;
  let modalElement = null;
  let listeners = [];
  let isInitialized = false;

  const normalizeLocale = (locale) => {
    if (!locale) return 'en';
    return locale.split('-')[0];
  };

  const format = (amount, multiplier, currencyCode, locale) => {
    const value = amount / multiplier;
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      useGrouping: true,
      notation: 'standard',
      currency: currencyCode.toUpperCase(),
      minimumFractionDigits: value % 1 === 0 ? 0 : 2,
      maximumFractionDigits: value % 1 === 0 ? 0 : 2,
    }).format(value);
  };

  const injectStyles = () => {
    if (document.getElementById('payment-style')) return;
    const style = document.createElement('style');
    style.id = 'payment-style';
    style.textContent = `
      .payment-modal-overlay {
        position: fixed;
        top: 0; left: 0; width: 100%; height: 100%;
        background: rgba(0, 0, 0, 0.6);
        display: flex; align-items: center; justify-content: center;
        z-index: 1000;
      }

      .payment-modal-content {
        width: 100%;
        max-width: 980px;
        padding: 0;
        border-radius: 12px;
        position: relative;
        box-shadow: 0 10px 20px rgba(0,0,0,0.2);
        display: flex;
        flex-direction: column;
        overflow: auto;
        max-height: 95vh;
        background-color: var(--background-color-payment-dialog);
        border: var(--payment-border);
      }

      @media (min-width: 768px) {
        .payment-modal-content #payment-loaded-content {
          display: flex;
          flex-direction: row;
        }
        .payment-details-column {
          flex: 0 0 40%;
        }
        .payment-form-column {
          flex: 0 0 60%;
        }
      }

      .payment-details-column {
        background-color: var(--background-color-paymentleft);
        color: var(--text-secondary);
        padding: 30px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        font-size: 14px;
      }

      .payment-details-column strong {
        font-size: 2.3rem;
        display: block;
        margin-bottom: 0rem;
        line-height: 2rem;
      }

     .interval-label {
        font-size: 1rem;
        margin-bottom: 1rem;
      }

      .payment-modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 1.5rem;
        font-weight: bold;
        margin-bottom: 1rem;
        margin-top: 3rem;
        margin-right: 0.5rem;
      }

      .payment-form-column {
        padding: 30px;
        background-color: var(--background-color-payment-dialog);
      }

      .payment-close-btn {
        position: absolute;
        top: 2px;
        right: 10px;
        background: none;
        border: none;
        font-size: 1.6rem;
        color: var(--text-primary);
        cursor: pointer;
        z-index: 2;
      }

      #payment-form {
        display: flex;
        flex-direction: column;
        gap: 0.4rem;
      }

      #payment-submit {
        padding: 10px 15px;
        background: var(--background-pay-button);
        color: white;
        border: none;
        border-radius: 6px;
        font-size: 1rem;
        cursor: pointer;
        display: block;
      }

      .payment-recurring-note {
        font-size: 0.875rem;
      }

      .payment-recurring-note.disabled {
        color: var(--text-tertiary);
        opacity: 0.5;
      }

      .payment-recurring-note.enabled {
        color: var(--text-tertiary);
        opacity: 1;
      }

      .hidden-until-loaded {
        display: none !important;
      }

      .spiner-container-payment {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 30px;
      }

      #payment-submit:disabled {
          background-color: #cccccc;
          color: #666666;
          cursor: not-allowed;
          opacity: 0.2;
        }

      @media (max-width: 480px) {
        .payment-modal-content {
          margin: 0px;
          width: 100%;
          border-radius:0px;
        }
      }

      @media (max-width: 767px) {
        .payment-modal-header {
          font-size: 1.5rem;
          margin-top: 0rem;
          margin-bottom: 0rem;
        }
        .payment-details-column strong {
          font-size: 1.5rem;
        }
        .payment-details-column br + br, .payment-details-column br:last-child {
          display: none;
        }
        .product-description {
          display: none;
        }
        .payment-details-column {
          padding: 15px 15px 10px 15px;
        }
        .payment-close-btn {
            color: white;
        }
        .payment-form-column {
          padding: 15px;
        }
        .payment-modal-content {
            height: max(90vh, var(--vh, 1vh) * 100);
        }
      }
    `;
    document.head.appendChild(style);
  };

  const formatNextDate = (interval) => {
    const now = new Date();
    let next;

    if (interval === 'month') {
      const year = now.getFullYear();
      const month = now.getMonth();
      const day = now.getDate();

      next = new Date(year, month + 1, day);

      if (next.getDate() !== day) {
        next = new Date(year, month + 2, 0);
      }
    } else {
      const year = now.getFullYear();
      const month = now.getMonth();
      const day = now.getDate();

      next = new Date(year + 1, month, day);

      if (next.getDate() !== day) {
        next = new Date(year + 1, month + 1, 0);
      }
    }

    return next.toLocaleDateString(undefined, {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  const loadStripeJS = () => {
    return new Promise((resolve, reject) => {
      if (window.Stripe) return resolve();
      const script = document.createElement('script');
      script.src = 'https://js.stripe.com/basil/stripe.js';
      script.onload = resolve;
      script.onerror = () => reject(new Error('Failed to load Stripe.js'));
      document.head.appendChild(script);
    });
  };

  const renderDialog = (planData) => {
    const existing = document.getElementById('payment-modal');
    if (existing) existing.remove();

    const intervalLabel = planData.interval === 'month' ? 'Monthly Subscription' : 'Annual Subscription';
    const nextChargeDate = formatNextDate(planData.interval);
    const recurringLabel = planData.interval === 'month' ? 'monthly' : 'annually';

    const modal = document.createElement('div');
    modal.className = 'payment-modal-overlay';
    modal.id = 'payment-modal';
    modal.innerHTML = `
      <div class="payment-modal-content">
        <button class="payment-close-btn" id="payment-close">×</button>
        <div id="payment-loaded-content" class="hidden-until-loaded">
          <div class="payment-details-column">
            <div id="plan-details">
              <strong>${planData.productName || ''}</strong>
              <div class="interval-label">${intervalLabel}</div>
              <span class="product-description">${planData.productDescription || ''}</span><br>
            </div>
            <div class="payment-modal-header">
              <span>${getI18n('amount_due')}</span>
              <span>${planData.formattedAmount || ''}</span>
            </div>
          </div>
          <div class="payment-form-column">
            <form id="payment-form">
              <div id="payment-element"></div>
              <button id="payment-submit" type="submit" disabled>Pay</button>
              <div id="payment-error-message" style="display: none; color: red; font-size: 0.9rem;"></div>
              <div class="payment-recurring-note disabled" id="payment-note">
                Pay ${planData.formattedAmount || ''} now, then ${planData.formattedAmount || ''} ${recurringLabel} starting ${nextChargeDate}.
              </div>
            </form>
          </div>
        </div>
        <span id="spinerContainerPayment" class="spiner-container-payment">
          <span class="spinner"></span>
        </span>
      </div>
    `;
    document.body.appendChild(modal);
    modalElement = modal;
    attachCloseListener();

    setTimeout(() => {
      const payBtn = modal.querySelector('#payment-submit');
      const note = modal.querySelector('#payment-note');
      if (payBtn) {
        payBtn.style.display = 'block';
      }

      if (paymentElement) {
        paymentElement.on('change', (event) => {
          if (payBtn) {
            payBtn.disabled = !event.complete;
          }
          if (note) {
            note.classList.toggle('enabled', event.complete);
            note.classList.toggle('disabled', !event.complete);
          }
            // ✅ Clear custom error message on any field change
            const errorDiv = document.getElementById('payment-error-message');
            if (errorDiv) {
              errorDiv.textContent = '';
              errorDiv.style.display = 'none';
            }
        });
      }
    }, 500);
  };




  const addListener = (target, type, handler) => {
    target.addEventListener(type, handler);
    listeners.push({ target, type, handler });
  };

  const attachCloseListener = () => {
    const closeButton = document.getElementById('payment-close');
    if (closeButton) {
      const closeHandler = () => unload();
      addListener(closeButton, 'click', closeHandler);
    }
  };

  const attachListeners = () => {
    const formElement = document.getElementById('payment-form');

    const submitHandler = async (e) => {
      e.preventDefault();

      const payBtn = document.getElementById('payment-submit');
      const errorDiv = document.getElementById('payment-error-message');
      if (errorDiv) {
        errorDiv.textContent = '';
        errorDiv.style.display = 'none';
      }

      if (payBtn) {
        payBtn.disabled = true;
        payBtn.textContent = 'Processing...';
      }

      const { error, paymentIntent } = await stripeInstance.confirmPayment({
        elements: elementsInstance,
        confirmParams: {
          return_url: window.location.href,
        },
        redirect: 'if_required'
      });

      if (error) {
        const errorDiv = document.getElementById('payment-error-message');

        const stripeFieldErrorExists = !!document.querySelector('.p-FieldError');

        console.log ('stripeFieldErrorExists', stripeFieldErrorExists);
        console.log ('errorDiv', errorDiv);

        // Only show if it's not handled by Stripe UI or is a backend/connection error
        if (!stripeFieldErrorExists && errorDiv) {
          errorDiv.textContent = error.message || 'Something went wrong. Please try again.';
          errorDiv.style.display = 'block';
        }


        if (payBtn) {
          payBtn.disabled = false;
          payBtn.textContent = 'Pay';
        }

        return;
      }


      if (paymentIntent && paymentIntent.status === 'succeeded') {
        const content = document.getElementById('payment-loaded-content');
        if (content) {
          content.innerHTML = `
        <div style="text-align:center; padding: 30px;">
          <h2 style="color: green; font-size: 1.5rem;">✅ Payment Confirmed</h2>
          <p>Your subscription is now active. Thank you!</p>
        </div>
      `;
        }
      }
    };
    addListener(formElement, 'submit', submitHandler);
    attachCloseListener();
  };



  const init = async () => {
    if (isInitialized) return;
    injectStyles();
    await loadStripeJS();
    isInitialized = true;
  };

  const open = async (clientSecret, planData) => {
    if (!isInitialized) {
      console.error('paymentDialog.init() must be called before open().');
      return;
    }
    if (!clientSecret) {
      console.error('Client secret is required to open the dialog.');
      return;
    }

    if (planData.stripePubishableKey){
      stripeInstance = Stripe(planData.stripePubishableKey);
    }

    const normalizedLocale = normalizeLocale(planData.locale);
    renderDialog(planData);


    renderDialog(planData);

    const isDarkTheme = $(parent.document).find('html').hasClass('dark-theme');
    const appearance = isDarkTheme ? { theme: 'night' } : {};

    elementsInstance = stripeInstance.elements({
      clientSecret,
      locale: normalizedLocale,
      appearance
    });
    paymentElement = elementsInstance.create("payment");
    paymentElement.mount("#payment-element");

    const spinner = document.getElementById('spinerContainerPayment');
    const payBtn = document.getElementById('payment-submit');
    const loadedContent = document.getElementById('payment-loaded-content');

    if (spinner) spinner.style.display = 'none';
    if (payBtn) payBtn.style.display = 'block';
    if (loadedContent) loadedContent.classList.remove('hidden-until-loaded');

    attachListeners();
  };

  const unload = () => {
    listeners.forEach(({ target, type, handler }) => {
      target.removeEventListener(type, handler);
    });
    listeners = [];

    if (paymentElement) {
      paymentElement.unmount();
      paymentElement = null;
    }

    const style = document.getElementById('payment-style');
    if (style) style.remove();

    if (modalElement) {
      modalElement.innerHTML = '';
      modalElement.remove();
      modalElement = null;
    }

    elementsInstance = null;
    isInitialized = false;
  };

  const startPayment = async (event, userInfo) => {
    event.preventDefault();

    const { email, vendor } = userInfo;

    const el = event.currentTarget;
    const planName = el.getAttribute('data-plan-name');
    const interval = el.getAttribute('data-active-interval') || 'monthly';
    const planDescription = el.getAttribute('data-plan-description') || '';
    const siteNameForStripe = getSiteNameForStripe();

    const compressed = sessionStorage.getItem('pricingDataCompressed');

    renderDialog({});
    const spinner = document.getElementById('spinerContainerPayment');
    if (spinner) spinner.style.display = 'flex';

    try {
      if (!isInitialized) {
        await init();
      }

      const url = getApiUrl('create-subscription-intent', 'geoapi');
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ planName, planDescription, email, vendor, siteNameForStripe, interval, compressed })
      });
      if (!res.ok) throw new Error(`Fetch failed with status ${res.status}`);
      const data = await res.json();

      if (data.clientSecret) {
        const formattedAmount = format(
          data.amount,
          data.multiplier,
          data.currency,
          data.locale,
        );
        await open(data.clientSecret, {
          productName: data.planName,
          productDescription: data.productDescription,
          amount: data.amount,
          formattedAmount: formattedAmount,
          interval: data.interval,
          currency: data.currency,
          priceId: data.priceId,
          subscriptionId: data.subscriptionId,
          locale: data.locale,
          stripePubishableKey: data.stripePubishableKey,
        });
      } else {
        throw new Error('Client secret not returned.');
      }
    } catch (err) {
      console.error('Payment intent fetch failed:', err);
      if (spinner) spinner.style.display = 'none';

      const loadedContent = document.getElementById('payment-loaded-content');
      if (loadedContent) loadedContent.classList.remove('hidden-until-loaded');

      const planDetails = document.getElementById('plan-details');
      if (planDetails) planDetails.innerHTML = '';

      const form = document.getElementById('payment-form');
      if (form) {
        const errorMsg = document.createElement('div');
        errorMsg.style.color = 'red';
        errorMsg.textContent = 'Something went wrong. Please try again.';
        form.appendChild(errorMsg);
      }

      attachCloseListener();
    }
  };

  return {
    init,
    unload,
    startPayment,
  };
})();

export default paymentDialog;
